import { useCallback, useSyncExternalStore } from 'react';
import {
  selectGroupGuid,
  selectUserGuid,
  useAppSelector,
} from 'slices/commonSelectors';
import {
  getHiddenAssetSymbolsSnapshot,
  hiddenAssetSymbolsStorageKey,
  setAssetSymbolsVisible,
  subscribeHiddenAssetSymbols,
} from './hiddenAssetSymbols';

const EMPTY: ReadonlySet<string> = new Set();

export interface HiddenAssetSymbols {
  hiddenIds: ReadonlySet<string>;
  setVisible: (resourceSetId: string, visible: boolean) => void;
  setManyVisible: (resourceSetIds: string[], visible: boolean) => void;
}

/** Hidden asset map symbols for the signed-in user in the current org. */
export function useHiddenAssetSymbols(): HiddenAssetSymbols {
  const userGuid = useAppSelector(selectUserGuid);
  const groupGuid = useAppSelector(selectGroupGuid);
  const key =
    userGuid && groupGuid
      ? hiddenAssetSymbolsStorageKey(userGuid, groupGuid)
      : '';

  const hiddenIds = useSyncExternalStore(
    subscribeHiddenAssetSymbols,
    () => getHiddenAssetSymbolsSnapshot(key),
    () => EMPTY
  );

  const setManyVisible = useCallback(
    (resourceSetIds: string[], visible: boolean) => {
      setAssetSymbolsVisible(key, resourceSetIds, visible);
    },
    [key]
  );
  const setVisible = useCallback(
    (resourceSetId: string, visible: boolean) => {
      setAssetSymbolsVisible(key, [resourceSetId], visible);
    },
    [key]
  );

  return { hiddenIds, setVisible, setManyVisible };
}
